export default class Paciente {
    private _id = Number();
    private _ativo = Boolean();
    private _dtInclusao = new Date();
    private _dtAlteracao = new Date();
    private _dtNascimento = new Date();
    private _usuario = String();
    private _usuarioUpdate = String();
    private _nome = String();
    private _nomeSocial = String();
    private _sexo = String();
    private _estadoCivil = String();
    private _cor = String();
    private _conjuge = String();
    private _rg = Number();
    private _cpf = Number();
    private _cartaoNacSus = String();
    private _endereco = String();
    private _complemento = String();
    private _bairro = String();
    private _numEndereco = Number();
    private _uf = String();
    private _cep = Number();
    private _email = String();
    private _naturalidade = String();
    private _celular = Number();
    private _telefone = Number();
    private _telefoneComercial = Number();

    public get id() {
        return this._id;
    }
    public set id(value) {
        this._id = value;
    }
    public get dtInclusao() {
        return this._dtInclusao;
    }
    public set dtInclusao(value) {
        this._dtInclusao = value;
    }
    public get dtAlteracao() {
        return this._dtAlteracao;
    }
    public set dtAlteracao(value) {
        this._dtAlteracao = value;
    }
    public get dtNascimento() {
        return this._dtNascimento;
    }
    public set dtNascimento(value) {
        this._dtNascimento = value;
    }
    public get usuario() {
        return this._usuario;
    }
    public set usuario(value) {
        this._usuario = value;
    }
    public get usuarioUpdate() {
        return this._usuarioUpdate;
    }
    public set usuarioUpdate(value) {
        this._usuarioUpdate = value;
    }
    public get ativo() {
        return this._ativo;
    }
    public set ativo(value) {
        this._ativo = value;
    }
    public get nome() {
        return this._nome;
    }
    public set nome(value) {
        this._nome = value;
    }
    public get nomeSocial() {
        return this._nomeSocial;
    }
    public set nomeSocial(value) {
        this._nomeSocial = value;
    }
    public get sexo() {
        return this._sexo;
    }
    public set sexo(value) {
        this._sexo = value;
    }
    public get estadoCivil() {
        return this._estadoCivil;
    }
    public set estadoCivil(value) {
        this._estadoCivil = value;
    }
    public get conjuge() {
        return this._conjuge;
    }
    public set conjuge(value) {
        this._conjuge = value;
    }
    public get rg() {
        return this._rg;
    }
    public set rg(value) {
        this._rg = value;
    }
    public get cpf() {
        return this._cpf;
    }
    public set cpf(value) {
        this._cpf = value;
    }
    public get cartaoNacSus() {
        return this._cartaoNacSus;
    }
    public set cartaoNacSus(value) {
        this._cartaoNacSus = value;
    }
    public get cor() {
        return this._cor;
    }
    public set cor(value) {
        this._cor = value;
    }
    public get endereco() {
        return this._endereco;
    }
    public set endereco(value) {
        this._endereco = value;
    }
    public get numEndereco() {
        return this._numEndereco;
    }
    public set numEndereco(value) {
        this._numEndereco = value;
    }
    public get complemento() {
        return this._complemento;
    }
    public set complemento(value) {
        this._complemento = value;
    }
    public get bairro() {
        return this._bairro;
    }
    public set bairro(value) {
        this._bairro = value;
    }
    public get uf() {
        return this._uf;
    }
    public set uf(value) {
        this._uf = value;
    }
    public get cep() {
        return this._cep;
    }
    public set cep(value) {
        this._cep = value;
    }
    public get email() {
        return this._email;
    }
    public set email(value) {
        this._email = value;
    }
    public get naturalidade() {
        return this._naturalidade;
    }
    public set naturalidade(value) {
        this._naturalidade = value;
    }
    public get celular() {
        return this._celular;
    }
    public set celular(value) {
        this._celular = value;
    }
    public get telefone() {
        return this._telefone;
    }
    public set telefone(value) {
        this._telefone = value;
    }
    public get telefoneComercial() {
        return this._telefoneComercial;
    }
    public set telefoneComercial(value) {
        this._telefoneComercial = value;
    }

    constructor(pId: number, pDtInclusao: Date, pDtAlteracao: Date, pDtNascimento: Date, pUsuario: string, pUsuarioUpdate: string, pAtivo: boolean, pNome: string, pNomeSocial: string, pSexo: string, pEstadoCivil: string, pConjuge: string, pRg: number, pCpf: number, pCartaoNacSus: string, pCor: string, pEndereco: string, pNumEndereco: number, pComplemento: string, pBairro: string, pUf: string, pCep: number, pEmail: string, pNaturalidade: string, pCelular: number, pTelefone: number, pTelefoneComercial: number) {
        this.id = pId;
        this.dtInclusao = pDtInclusao;
        this.dtAlteracao = pDtAlteracao;
        this.dtNascimento = pDtNascimento;
        this.usuario = pUsuario;
        this.usuarioUpdate = pUsuarioUpdate;
        this.ativo = pAtivo;
        this.nome = pNome;
        this.nomeSocial = pNomeSocial;
        this.sexo = pSexo;
        this.estadoCivil = pEstadoCivil;
        this.conjuge = pConjuge;
        this.rg = pRg;
        this.cpf = pCpf;
        this.cartaoNacSus = pCartaoNacSus;
        this.cor = pCor;
        this.endereco = pEndereco;
        this.numEndereco = pNumEndereco;
        this.complemento = pComplemento;
        this.bairro = pBairro;
        this.uf = pUf;
        this.cep = pCep;
        this.email = pEmail;
        this.naturalidade = pNaturalidade;
        this.celular = pCelular;
        this.telefone = pTelefone;
        this.telefoneComercial = pTelefoneComercial;
    }
}